<template>
    <rkm-form
        ref="RkmForm"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    label="Motivo da Evasão"
                    v-model="model.motivoEvasao"
                    :validations="validations.motivoEvasao"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                motivoEvasao: { required: true, max: 500 },
            }
        },
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('prontoAtendimento.fila')
        }
    },
    data: () => ({
        model: {
            motivoEvasao: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    this.setLoading()

                    if (this.id) {
                        this.repositories.fila.evade(this.id, this.camelObjectKeysToSnakeRecursive(this.model))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
    },
    mixins: [ error, repository, stringCase ],
    props: {
        id: { type: [Number, String] },
    }
}
</script>